import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React from "react";
import { ReactComponent as DialogAlert } from "../assets/images/dialog-alert.svg";
import { ReactComponent as WarningAlert } from "../assets/images/wraning.svg";
import { ReactComponent as Trash } from "../assets/images/trash.svg";
import CloseIcon from "../assets/images/plus-circle-fill.svg";

const ConfirmDialog = (props) => {
  const { t } = useTranslation()
  const handleClose = () => {
    props.setValue(false)
  };
  const [valRadio, setValRadio] = React.useState(true);

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="form-add-dialog-title" fontSize="1.3rem" color="#404349">
          {props.title}
          <Box sx={{ position: "absolute", right: 0, margin: "20px 18px 0  0", top: 0 }} className="clickable" onClick={handleClose}><img src={CloseIcon} alt="browser" /></Box>
          <Divider sx={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexFlow: 'column' }} component="div">
            {
              props.trash === true ? <Trash></Trash> : props.warning === true ? <WarningAlert></WarningAlert> : <DialogAlert></DialogAlert>
            }
            {props.twoText ?
              <Typography mt={3} fontSize={16} sx={{ textAlign: "center" }} dangerouslySetInnerHTML={{ __html: props.text }} color="#404349" ></Typography>
              : props.twoLines ?
                <>
                  <Typography mt={3} fontSize={18} lineHeight="26.91px" color="#404349" sx={{ textAlign: "center" }}>{props.text}</Typography>
                  <Typography mt="5px" fontSize={16} lineHeight="23.92px" color="#A3A3A3" sx={{ textAlign: "center" }}>{props.subtext}</Typography>
                </>
                :
                <Typography mt={3} fontSize={16} color="#404349" sx={{ textAlign: "center" }}>{props.text}</Typography>
            }
            {props.confirmNext ?
              <Box mt="15px">
                <RadioGroup sx={{ ".MuiTypography-root": { color: "#404349" } }}
                  value={valRadio}
                  onChange={(newValue) => {
                    setValRadio(newValue.target.value);
                  }}>
                  <FormControlLabel value={true} control={<Radio />} label={t('360Evaluation.label.yesComplete')} />
                  <FormControlLabel value={false} control={<Radio />} label={t('360Evaluation.label.noAddMore')} />
                </RadioGroup>
              </Box>
              : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <Button onClick={handleClose} size="medium" variant="outlined" sx={{ minWidth: '150px', marginRight: "10px", textTransform: "none" }} color="black">{props.submit === true ? t("label.cancel") : t("label.notSure")}</Button>
          <Button onClick={() => props.confirmNext ? props.doConfirmV2(valRadio) : props.doConfirm()} size="medium" variant="contained" sx={{ minWidth: '150px', textTransform: "none" }} color={props.warning === true ? "warning" : "red"}>{props.submit === true ? t("label.confirm") : t("label.ofCourse")}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default ConfirmDialog;
